var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 5.757c-3.387 0-6.194 2.758-6.194 6.194A6.175 6.175 0 0 0 12 18.144c3.435 0 6.194-2.806 6.194-6.193S15.387 5.757 12 5.757m0 10.162a3.986 3.986 0 0 1-3.968-3.968A3.986 3.986 0 0 1 12 7.983a3.986 3.986 0 0 1 3.968 3.968A3.986 3.986 0 0 1 12 15.919M18.436 7.015a1.403 1.403 0 1 0 0-2.806 1.403 1.403 0 0 0 0 2.806"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.065 1.983C20.806.676 19.016-.001 16.984-.001H7.016C2.806-.001 0 2.805 0 7.015v9.92c0 2.08.677 3.87 2.032 5.177 1.307 1.258 3.049 1.887 5.033 1.887h9.87c2.081 0 3.823-.677 5.081-1.887C23.323 20.854 24 19.064 24 16.982V7.016c0-2.032-.677-3.774-1.936-5.032m-.194 15c0 1.5-.532 2.71-1.403 3.532s-2.08 1.258-3.532 1.258H7.065c-1.452 0-2.662-.435-3.533-1.258-.87-.87-1.306-2.08-1.306-3.58v-9.92c0-1.451.435-2.661 1.306-3.532.823-.823 2.08-1.258 3.533-1.258h9.967c1.452 0 2.662.435 3.532 1.306.823.871 1.307 2.08 1.307 3.484z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0-.001h24v24H0z"
  })))));
};
export default SvgInstagram;